import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";
import { VerificationsReducer } from ".";
import { composeWithDevTools } from "redux-devtools-extension";

const reducers = {
	verifications: VerificationsReducer,
};

export default function configureStore(initialState: { verifications?: undefined } | undefined) {
	const middleware = [thunk];

	const isDevelopment = process.env.NODE_ENV === "development";

	const rootReducer = combineReducers({
		...reducers,
	});

	if (isDevelopment) {
		return createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)));
	}

	return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware)));
}
